function fnProjectsHero(i, oSection) {
	const bgSwiper = new Swiper(oSection.querySelector('.bg'), {
		loop: true,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		pagination: {
			el: oSection.querySelector('.swiper-dots.mobile')
		},
	})

	const contentSwiper = new Swiper(oSection.querySelector('.content-swiper'), {
		loop: true,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		pagination: {
			el: oSection.querySelector('.swiper-dots.desktop'),
			clickable: true
		},
		controller: {
			control: bgSwiper
		},
		autoplay: {
			delay: 8000
		}
	})
}
